import {
	ChatClient
} from '@/clients/ChatClient';

export const ChatModule = {
	namespaced: true,

	state: {
		chat: null,
		chats: [],
		activeChatIndex: null,
		participants: [],
		titleImageUrl: '',
		isChatOpen: false,
		showTypingIndicator: '', // when set to a value matching the participant.id it shows the typing indicator for the specific user
		alwaysScrollToBottom: false,
		messageStyling: true,
	},
	getters: {
		activeChat: state => {
			if (state.activeChatIndex != null) {
				return state.chats[state.activeChatIndex]
			}
			return null
		},
		guestUserImage: state => {
			//This works but image is too big
			// if(state.chat) {
			//
			//
			//     let sender = state.chat.attributes.users.filter(function (user) {
			//         return !user.attributes.is_current_user;
			//     });
			//     if (sender) {
			//         return sender[0].attributes.user.attributes.profile_image;
			//     }
			// }

			return 'https://a.slack-edge.com/66f9/img/avatars-teams/ava_0001-34.png';

		}
	},
	actions: {
		setParticipants({
			commit,
			state
		}, users) {
			commit('SET_PARTICIPANTS', users)
		},
		showChat({
			commit
		}) {
			commit('SHOW_CHAT');
		},
		clearNew({
			commit,
			state
		}) {
			commit('CLEAR_NEW', state.activeChatIndex);
		},
		closeChat({
			commit
		}) {
			commit('CLOSE_CHAT');
		},
		getPrivateChat({
			commit,
			state
		}, recipient_id) {
			return ChatClient.getPrivateChatByRecipient(recipient_id).then(function (res) {
				if (!state.chats.some(chat => chat.id == res.data.data.id)) {
					commit('SET_CHAT', res.data.data);
				}
				commit('SET_ACTIVE_CHAT', res.data.data.id)
			}).catch((err) => {});
		},
		sendMessage({
			commit,
			state,
			getters
		}, message) {
			return ChatClient.sendMessage(getters.activeChat.id, message).then((res) => {
				commit('NEW_MESSAGE', res.data.data)
			})
		},
		setNewMessage({
			commit,
			state,
			getters
		}, message) {
			if (getters.activeChat.id != message.attributes.chat_id || !state.isChatOpen) {
				commit('INCREMENT_NEW_MESSAGES', message.attributes.chat_id)
			}
			commit('NEW_MESSAGE', message)
		}
	},

	mutations: {
		SET_ACTIVE_CHAT(state, chat_id) {
			state.activeChatIndex = state.chats.findIndex(chat => chat.id == chat_id)
		},
		SET_CHAT(state, chat) {
			state.chats.push(chat);
		},
		CLEAR_NEW(state, chat_index) {
			state.chats[chat_index].newMessages = 0;
		},
		SET_PARTICIPANTS(state, users) {
			state.participants = users;
		},
		SHOW_CHAT(state) {
			state.isChatOpen = true;
		},
		CLOSE_CHAT(state) {
			state.isChatOpen = false;
		},
		INCREMENT_NEW_MESSAGES(state, chat_id) {
			state.chats[state.chats.findIndex(chat => chat.id == chat_id)].newMessages++
		},
		NEW_MESSAGE(state, message) {
			state.chats[state.chats.findIndex(chat => chat.id == message.attributes.chat_id)].attributes.messages.push(message)
		},

	}
}
